import React from 'react';

// Utilizziamo il percorso fornito dall'utente sul dominio bottegadellevoci.it
const BASE_IMG_PATH = 'https://www.bottegadellevoci.it/Foto';
const GALLERY_BASE_PATH = 'https://www.bottegadellevoci.it/Gallery';
const BASE_VIDEO_PATH = 'https://www.bottegadellevoci.it/Video';
const BASE_AUDIO_PATH = 'https://www.bottegadellevoci.it/Audio';

// Versione per il "Cache Busting" - incrementa questo numero se sostituisci le foto sul server
const GALLERY_VERSION = '2';

// Configurazione Gallery: 134 foto (da 1 a 134)
const generatedGallery = Array.from({ length: 134 }, (_, i) => ({
  url: `${GALLERY_BASE_PATH}/${i + 1}.jpg?v=${GALLERY_VERSION}`,
  caption: "" 
}));

export const SITE_CONTENT = {
  navigation: [
    { id: 'home', label: 'Home' },
    { id: 'tecnica', label: 'La nostra tecnica' },
    { id: 'maestro', label: 'Il Maestro' },
    { id: 'gallery', label: 'Gallery' },
    { id: 'repertorio', label: 'Repertorio' },
    { id: 'media', label: 'Video & MP3' },
    { id: 'contatti', label: 'Contatti' },
  ],
  hero: {
    overline: "Coro Polifonico",
    title: "La Bottega Delle Voci",
    subtitle: "L'arte dell'armonia corale tra tradizione e innovazione.",
    image: `${BASE_IMG_PATH}/Hero2.jpg`,
    logos: {
      primary: `${BASE_IMG_PATH}/Logo.jpg`,
      secondary: `${BASE_IMG_PATH}/Logo2.jpg`
    },
    cta: "Scopri le nostre voci"
  },
  concerti: [] as Array<{ data: string; ora: string; titolo: string; luogo: string; nota?: string }>,
  tecnica: {
    title: "La nostra tecnica",
    description: "La Bottega delle Voci è un ensemble flessibile e modulare, capace di adattarsi a diversi contesti performativi. Di seguito i dettagli tecnici per le nostre esecuzioni:",
    points: [
      { 
        title: "Vocalist", 
        text: "Numero dei vocalist 15/18 circa, di tipo misto (femminile e maschile), suddivisi in 4 - 6 voci, con possibili solisti." 
      },
      { 
        title: "Spazio scenico necessario", 
        text: "Anche ridotto al semplice spazio fisico dei coristi." 
      },
      { 
        title: "Esigenze e strumentazione tecnica", 
        text: "Nessuna, grazie alla flessibilità del gruppo ed alla modularità richiesta è possibile l'esecuzione a cappella oppure con ausilio di altri strumenti musicali, fino all'ipotetica esecuzione con orchestra." 
      },
      { 
        title: "Altri strumenti musicali", 
        text: "Generalmente nello spettacolo completo è richiesto l'ausilio di basso elettrico, pianoforte (tastiere), flauto traverso ed elementi percussivi, amplificazione: in teatri con buona acustica ed in piccoli chiostri non è necessaria amplificazione, mentre in altri luoghi all'aperto come grandi piazze, ampi spazi, utilizziamo un service audio la cui potenza varia a seconda del luogo e della situazione presente." 
      }
    ],
    image: `${BASE_IMG_PATH}/Tecnica.jpg`
  },
  maestro: {
    title: "Il Maestro",
    name: "M° Fabio Mengucci",
    bio: `Il Maestro Fabio Mengucci è nato a Senigallia (AN) il 28/07/1971, è laureato al Conservatorio "G. Rossini" di Pesaro in Didattica della Musica ed in Flauto Traverso. Ha partecipato a numerosi concorsi Nazionali ed Internazionali, nonché corsi di perfezionamento strumentale vocale e didattico. 

Numerosissime sono le esibizioni con i più svariati gruppi musicali di ogni genere: Quartetto di Flauti "Cluster", Sestetto "Project Ensamble" (voce, flauto, violino, clarinetto, flicorno e pianoforte), flautista per l'Orchestra Sinfonica di Pesaro (OSP) esibendosi anche in Francia e per l'orchestra dello spettacolo "Jesus Christ Superstar" di Senigallia. 

E' stato esperto di Educazione Musicale in alcune Scuole elementari di Pesaro e Cattolica dal 1996 al 2000 ed a Mondaino dal 2002 al 2004, nelle quali ha realizzato diversi spettacoli per i ragazzi tra i quali ricordiamo: "Il Viaggio", "Pinocchio", "Matilde sei mitica!". Ha contribuito alla realizzazione dello spettacolo "Nel Blu" del M° Fabio Masini, arrangiando due brani per Coro e Band e nel quale è stato cantante solista per gli anni 2000, 2001, 2006 esibendosi anche in Piazza della Signoria a Firenze, in Piazza dei Priori a Volterra, al Teatro Comunale di Carpi, al Teatro Masini di Faenza, alla Cava dei Balestrieri di San Marino. 

Ha collaborato dal 2000 al 2004 come insegnante nella Scuola di Musica di Serravalle (RSM). Collabora dal 2003 con l' Associazione "Teatro dei Cinque-Quattrini" - Saludecio di Silvia Giorgi, dove ha contribuito alla produzione e realizzazione dello Spettacolo "C-Red...recupero di una memoria" componendo alcuni brani musicali e partecipando in veste di attore-cantante. 

Dal 2002 il Maestro dirige il Coro "San Giuseppe" - Città di Gradara, il quale ha cominciato ad esplorare nuovi campi meno conosciuti ma molto cari alla realtà cittadina di Gradara, come quello dei canti medievali proposti nel nuovo Spettacolo "...Dal Tempo di Paolo e Francesca". 

E' attualmente Direttore a Arrangiatore del Coro Laboratorio "La Bottega della Voci" da Cattolica dal 1996 con il quale sono stati realizzati numerosi spettacoli tra cui "Mirabilia", "il Canto degli angeli", "...e le rose fioriranno", "Amore Baciami", "Per un ora d'amore", e ora il più recente spettacolo: "Sulle Ali del Vento" e "Schegge di Emozioni" del 2008.`,
    image: `${BASE_IMG_PATH}/Maestro.jpg`
  },
  gallery: generatedGallery,
  repertorio: {
    title: "Il Nostro Repertorio",
    intro: "I brani che eseguiamo in concerto...",
    image: `${BASE_IMG_PATH}/Repertorio.jpg?v=1.1`,
    genres: [
      { 
        name: "Internazionali", 
        pieces: [
          "Bohemian Rhapsody (Queen)",
          "Somebody To Love (Queen)",
          "Roxanne (Police)",
          "What a Wonderful World (Louis Armstrong)",
          "Mamma Mia (Abba)",
          "Dancing Queen (Abba)",
          "Operator Spiritual (Anonimo)",
          "Everybody Sing Freedom Spiritual (Anonimo)",
          "Chattanooga Choo Choo (Harry Warren/Mack Gordon)",
          "Yesterday (J.Lennon - P. McCartney)",
          "How deep is your love (Bee Gees)",
          "I Say a Little Prayer (Aretha Franklin/Burt Bacharac)",
          "Can't help falling in love (Elvis Presley)",
          "Lollipop (J.Dixson/B.Ross)",
          "Africa (Toto)",
          "Hallelujah (Leonard Cohen)"
        ] 
      },
      { 
        name: "Anni '40 - '70", 
        pieces: [
          "Solo Tu (Matia Bazar)",
          "Un Bacio a Mezzanotte (G.Kramer)",
          "E Se Domani (Mina/C.A.Rossi)",
          "Geordie (F.De Andrè)",
          "Ma L'amore No (D'Anzi/Savio)",
          "Ma Le Gambe (G. Kramer)",
          "Sogni Nel Blu (Modugno/Migliacci)",
          "Il Gatto e la Volpe (E.Bennato)",
          "Nessun Dolore (Mogol/Battisti)",
          "Cuore Matto (Ambrosino/Savio)",
          "Un’Avventura (Mogol/Battisti)",
          "Il Mio Canto Libero (Mogol/Battisti)",
          "Maramao Perché Sei Morto (Consiglio/Panzeri)",
          "Però Mi Vuole Bene (Savona/Cichellero/Giacobetti)"
        ] 
      },
      { 
        name: "Canti Sacri e Natalizi", 
        pieces: [
          "Adeste Fideles (Canto tradizionale del Sec.XVI)",
          "Pater Noster (Nikolai Kedrov)",
          "Inno alla Notte (Ludwig van Beethoven)",
          "Laudate Dominum (Wolfgang Amadeus Mozart)",
          "Gaudete (Canto tradizionale inglese del ‘500)",
          "Bianco Natale (Irving Berlin)",
          "Jingle Bell Rock (J.C.Beal/J.R.Boothe)",
          "O Holy Night (Adolphe Adam)",
          "Silent Night (Franz Xaver Gruber)",
          "Stella Cometa (Fabio Mengucci/Arturo Monaco)",
          "Notte di Luce (Jo Akepsimas)",
          "In notte Placida (François Couperin)",
          "Ninna Nanna (Johannes Brahms)",
          "Ave Verum Corpus (Wolfgang Amadeus Mozart)",
          "Tu Scendi dalle Stelle (Sant'Alfonso Maria dè Liguori)",
          "Notte Santa (Bepi De Marzi)",
          "Ave Maria (Jacques Arcadelt)"
        ] 
      },
      { 
        name: "Anni '80 - Recenti", 
        pieces: [
          "Come Saprei (Ramazzotti/Giorgia Todrani)",
          "Lei Verrà (Mango/Salerno)",
          "Oro (Mango/Mogol)",
          "Vacanze Romane (Matia Bazar)"
        ] 
      }
    ]
  },
  media: {
    videos: [
      { id: "v1", url: `${BASE_VIDEO_PATH}/1.mp4`, title: "Come Saprei (Ramazzotti/Giorgia Todrani)", type: "local" },
      { id: "v2", url: `${BASE_VIDEO_PATH}/2.mp4`, title: "E Se Domani (Mina/C.A.Rossi)", type: "local" },
      { id: "v3", url: `${BASE_VIDEO_PATH}/3.mp4`, title: "Bohemian Rhapsody (Queen)", type: "local" },
      { id: "v4", url: `${BASE_VIDEO_PATH}/4.mp4`, title: "Lei Verrà (Mango/Salerno)", type: "local" },
      { id: "v5", url: `${BASE_VIDEO_PATH}/5.mp4`, title: "Oro (Mango/Mogol)", type: "local" },
      { id: "v6", url: `${BASE_VIDEO_PATH}/6.mp4`, title: "Il Gatto e la Volpe (E.Bennato)", type: "local" },
      { id: "v7", url: `${BASE_VIDEO_PATH}/7.mp4`, title: "Un Bacio a Mezzanotte (G.Kramer)", type: "local" },
      { id: "v8", url: `${BASE_VIDEO_PATH}/8.mp4`, title: "Mamma Mia (Abba)", type: "local" },
      { id: "v9", url: `${BASE_VIDEO_PATH}/9.mp4`, title: "Hallelujah (Leonard Cohen)", type: "local" },
      { id: "v10", url: `${BASE_VIDEO_PATH}/10.mp4`, title: "Geordie (F.De Andrè)", type: "local" },
      { id: "v11", url: `${BASE_VIDEO_PATH}/11.mp4`, title: "Ma Le Gambe (G. Kramer)", type: "local" },
      { id: "v12", url: `${BASE_VIDEO_PATH}/12.mp4`, title: "Can't help falling in love (Elvis Presley)", type: "local" },
      { id: "v13", url: `${BASE_VIDEO_PATH}/13.mp4`, title: "Lollipop (J.Dixson/B.Ross)", type: "local" },
      { id: "v14", url: `${BASE_VIDEO_PATH}/14.mp4`, title: "What a Wonderful World (Louis Armstrong)", type: "local" },
      { id: "v15", url: `${BASE_VIDEO_PATH}/15.mp4`, title: "Silent Night (Franz Xaver Gruber)", type: "local" },
      { id: "v16", url: `${BASE_VIDEO_PATH}/16.mp4`, title: "Bianco Natale (Irving Berlin)", type: "local" },
      { id: "v17", url: `${BASE_VIDEO_PATH}/17.mp4`, title: "Operator Spiritual (Anonimo)", type: "local" },
      { id: "v18", url: `${BASE_VIDEO_PATH}/18.mp4`, title: "O Holy Night (Adolphe Adam)", type: "local" },
      { id: "v19", url: `${BASE_VIDEO_PATH}/19.mp4`, title: "Gaudete (Canto tradizionale inglese del ‘500)", type: "local" },
      { id: "v20", url: `${BASE_VIDEO_PATH}/20.mp4`, title: "Laudate Dominum (Wolfgang Amadeus Mozart)", type: "local" },
    ],
    audios: [
      { url: `${BASE_AUDIO_PATH}/1.mp3`, title: "Solo Tu (Matia Bazar)", type: "mp3" },
      { url: `${BASE_AUDIO_PATH}/2.mp3`, title: "Ma L'amore No (D'Anzi/Savio)", type: "mp3" },
      { url: `${BASE_AUDIO_PATH}/3.mp3`, title: "Come Saprei (Ramazzotti/Giorgia Todrani)", type: "mp3" },
      { url: `${BASE_AUDIO_PATH}/4.mp3`, title: "Ma Le Gambe (G. Kramer)", type: "mp3" },
      { url: `${BASE_AUDIO_PATH}/5.mp3`, title: "Lei Verrà (Mango/Salerno)", type: "mp3" },
      { url: `${BASE_AUDIO_PATH}/6.mp3`, title: "Somebody To Love (Queen)", type: "mp3" },
      { url: `${BASE_AUDIO_PATH}/7.mp3`, title: "Un Bacio a Mezzanotte (G.Kramer)", type: "mp3" },
      { url: `${BASE_AUDIO_PATH}/8.mp3`, title: "E Se Domani (Mina/C.A.Rossi)", type: "mp3" },
      // Aggiungi qui altri audio seguendo lo schema sopra
    ]
  },
  location: {
    address: `Associazione Musicale "La Bottega delle Voci"
Via Del Prete, 33
47841 - Cattolica (RN)`,
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2874.05!2d12.745!3d43.965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132ce96660146059%3A0x600b33379659060!2sVia%20Giosu%C3%A8%20Carducci%2C%2047841%20Cattolica%20RN!5e0!3m2!1sit!2sit!4v1708700000000!5m2!1sit!2sit"
  }
};